module.exports = __webpack_public_path__ + "static/img/errenmj_small.434594e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/errenmj_small.png
// module id = P41L
// module chunks = 0